<template>

    <div class="date-picker-wrapper" :class="{'row': !isFloat}">
        <div v-if="!isFloat" class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group" :class="{'col-sm-8': !isFloat, 'form-group--centered': isCentered }">
            <label v-if="isFloat && label">{{ label }}<span class="base__mandatory" v-if="mandatory">*</span></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="zmdi zmdi-calendar"></i></span>
                </div>
                <input  :data-vv-as="label" :class="[{ 'form-control--active': isLabelFloatActive, 'is-invalid': errors && errors.has(name)}]"
                         v-validate="getValidators"  :id="id" :name="name" type="text" class="form-control date-picker">
            </div>
            <div class="invalid-feedback">
                {{ errors && errors.first(name) }}
            </div>
        </div>
    </div>
</template>

<script>
    import '@/assets/scss/vendors/initiativedesign/vendors/flatpickr/flatpickr.min.css'
    import '@/assets/scss/vendors/initiativedesign/vendors/flatpickr/flatpickr.js'
    import '@/assets/scss/vendors/initiativedesign/scss/components/_flatpickr.scss'
    import formElementMixin from '@/components/mixins/FormElementMixin'
    export default {
        mixins: [formElementMixin],

        props: {
            dateFormat: {
                type: String,
                default: 'dd-mm-YYYY'
            }
        },

        computed: {
            convertedDateFormat() {
                return this.dateFormat.replace('dd', 'd').replace('mm', 'm').replace('yyyy', 'Y')
            }
        },

        mounted() {
            if ($('.date-picker')[0]) {
                $('.date-picker').flatpickr({
                    enableTime: false,
                    nextArrow: '<i class="zmdi zmdi-long-arrow-right" />',
                    prevArrow: '<i class="zmdi zmdi-long-arrow-left" />',
                    defaultDate: this.displayValue,
                    dateFormat: this.convertedDateFormat,
                    onChange: (selectedDates, dateStr, instance) => {
                        this.$emit('input', dateStr)
                    },
                });
            }
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/form_elements/_datepicker.scss";</style>